import { createNewHandbookApi } from '@/api/handbookApi'
import { POSITION_PROPERTY_URL } from '@/api/handbook/position'
import { createHandbookResponseErrors } from '@/utils/error/responseErrors'

const REFERENCE_TURN_URL = `${POSITION_PROPERTY_URL}/reference-turns`

const errors = createHandbookResponseErrors('опорный виток', 'опорных витков')

export const ReferenceTurnApi = createNewHandbookApi(REFERENCE_TURN_URL, errors)
